import {CommonActions} from '@react-navigation/native';
import {Platform} from 'react-native';
import {
  CardReissueEsiaAttempt,
  captureCardReissueEsiaAttempt,
  clearCardReissueEsiaPending,
  hasCardReissueEsiaContext,
  isCardReissueEsiaAttemptCurrent,
  isCardReissueEsiaOAuthReturn,
  isCardReissueEsiaPending,
} from '../storage/cardReissueEsia';
import {rootNavigationRef} from './navigation';
import {Routes, Screens} from './model';

// Keep a confirmed return until the navigator is ready, even after the query is cleared.
let pendingEsiaReturn: CardReissueEsiaAttempt | null = null;

const hasPendingEsiaReturn = () => pendingEsiaReturn && isCardReissueEsiaAttemptCurrent(pendingEsiaReturn);

export const restoreCardReissuePathAfterEsia = (force = false) => {
  if (Platform.OS !== 'web' || typeof window === 'undefined') return;
  if (!force) {
    if (!isCardReissueEsiaOAuthReturn()) return;
    pendingEsiaReturn = captureCardReissueEsiaAttempt();
  }
  const {pathname, search, hash, origin} = window.location;
  if (pathname === Routes.cardReissue || pathname === `${Routes.cardReissue}/`) return;
  window.history.replaceState(window.history.state, '', `${origin}${Routes.cardReissue}${search}${hash}`);
};

export const navigateToCardReissue = () => {
  restoreCardReissuePathAfterEsia(true);

  if (!rootNavigationRef.isReady()) return;

  pendingEsiaReturn = null;
  const routeNames = rootNavigationRef.getRootState()?.routeNames ?? [];
  if (routeNames.includes(Screens.MainTabs)) {
    rootNavigationRef.dispatch(CommonActions.navigate({name: Screens.MainTabs, params: {screen: Screens.CardReissue}}));
    return;
  }
  rootNavigationRef.dispatch(CommonActions.navigate({name: Screens.CardReissue}));
};

export const resumeCardReissueAfterEsia = () => {
  if (!isCardReissueEsiaPending()) {
    pendingEsiaReturn = null;
    return;
  }
  if (Platform.OS === 'web' && !hasPendingEsiaReturn() && !isCardReissueEsiaOAuthReturn()) return;
  navigateToCardReissue();
};

export const clearCardReissueEsiaOnLeave = () => {
  if (Platform.OS !== 'web' || !rootNavigationRef.isReady()) return;
  if (!hasCardReissueEsiaContext()) return;
  if (isCardReissueEsiaPending() && (hasPendingEsiaReturn() || isCardReissueEsiaOAuthReturn())) return;
  const route = rootNavigationRef.getCurrentRoute();
  if (route && route.name !== Screens.CardReissue) {
    void clearCardReissueEsiaPending();
  }
};
